import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Atmosphere } from "@/components/atmosphere/Atmosphere";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { Hero } from "@/components/sections/Hero";
import { NullSixSection } from "@/components/sections/NullSixSection";
import { BooksSection } from "@/components/sections/BooksSection";
import { StatusSection } from "@/components/sections/StatusSection";
import { WaitlistSection } from "@/components/sections/WaitlistSection";
import { FragmentTray } from "@/components/secrets/ManualTransmit";
import { useSeo } from "@/hooks/use-seo";

export default function Home() {
  const { hash } = useLocation();

  useSeo({
    title: "The Fractured Five — six seconds missing, two thousand dead",
    description:
      "Official site of The Fractured Five by Tommy Green. Books One and Two, The Fracture and The Weight of Blood, are out now in ebook and paperback. Six books, five civilisations, 6.13 seconds that no record can explain. Read the opening chapter free.",
    path: "/",
    type: "website"
  });

  useEffect(() => {
    document.title =
      "The Fractured Five — six seconds missing, two thousand dead";
  }, []);

  useEffect(() => {
    if (!hash) return;
    const el = document.querySelector(hash);
    if (el) {
      window.requestAnimationFrame(() =>
        el.scrollIntoView({ behavior: "smooth", block: "start" })
      );
    }
  }, [hash]);

  return (
    <>
      <Atmosphere />
      <div className="relative z-10 min-h-screen">
        <SiteHeader />
        <main>
          <Hero />
          <NullSixSection />
          <BooksSection />
          <StatusSection />
          <WaitlistSection />
        </main>
        <SiteFooter />
      </div>
      <FragmentTray />
    </>
  );
}
